import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconWrapper from "../../../../common/components/functional/icons/IconWrapper";
import { FlexVerticalAligned } from "../../../../common/components/styled/styled";
import { ReactComponent as EmailIcon } from "../../../../common/icons/email-envelope.svg";
import { ReactComponent as PhoneIcon } from "../../../../common/icons/phone.svg";
import { ReactComponent as PinIcon } from "../../../../common/icons/pin.svg";
import { ReactComponent as CalendarIcon } from "../../../../common/icons/calendarEmpty.svg";
import { Talent } from "../../../talents/talentAPI";
import { formatTalentAddress } from "../../helpers";
import { format } from "date-fns";
import { leadingZerosDateFormat } from "../../../../common/helpers/formatDateTime";

type Props = {
  talent: Talent;
  previewMode?: boolean;
};

export const BasicInfo = ({ talent, previewMode = false }: Props) => {
  const { t } = useTranslation("common");
  const address = formatTalentAddress(talent.account);
  const birthDate = talent.account?.dob
    ? format(new Date(talent.account.dob), leadingZerosDateFormat)
    : null;

  return (
    talent?.account && (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
        }}
      >
        <FlexVerticalAligned gap="12px">
          <IconWrapper sx={{ fontSize: 14 }} icon={EmailIcon} />
          <Typography sx={{ wordBreak: "break-all" }}>
            {talent.account?.emailAddress || t("common:notSet")}
          </Typography>
        </FlexVerticalAligned>
        <FlexVerticalAligned gap="12px">
          <IconWrapper
            sx={{
              fontSize: 14,
              "& path, & g path": {
                fill: "text.secondary",
                fillOpacity: "0.52",
                strokeWidth: 1,
              },
            }}
            icon={PhoneIcon}
          />
          <Typography>
            {talent.account?.phoneNumber || t("common:notSet")}
          </Typography>
        </FlexVerticalAligned>
        <FlexVerticalAligned gap="12px">
          <IconWrapper sx={{ fontSize: 14 }} icon={PinIcon} />
          <Typography>{address || t("common:notSet")}</Typography>
        </FlexVerticalAligned>
        {previewMode && (
          <FlexVerticalAligned gap="12px">
            <IconWrapper sx={{ fontSize: 14 }} icon={CalendarIcon} />
            <Typography>{birthDate || t("common:notSet")}</Typography>
          </FlexVerticalAligned>
        )}
      </Box>
    )
  );
};
